module.exports = __webpack_public_path__ + "img/ecuador.3a0c50b.webp";